import moment from 'moment';
import * as yup from 'yup';

const errorMessage = 'Vinsamlegast skiljið reitinn ekki eftir auðann';

export const TravelVoucherFormValidation = yup.object().shape({
  employeeName: yup.string().required(errorMessage),
  approverName: yup.string().required(errorMessage),
  tripErrand: yup.string().required(errorMessage),
  tripPurpose: yup.string().required(errorMessage),
  country: yup.string().required(errorMessage),
  customCountry: yup.string().when('country', {
    is: 'Annað',
    then: () => yup.string().required(errorMessage),
  }),
  city: yup.string().required(errorMessage),
  // departureTime: yup.string().required(errorMessage),
  // arrivalTime: yup.string().required(errorMessage),
  departureDate: yup.string().required(errorMessage),
  arrivalDate: yup.string().required(errorMessage),
  addExtraDays: yup
    .number()
    .nullable()
    .transform((currentValue, originalValue) => {
      return originalValue === '' ? null : currentValue;
    })
    .test(
      'is-valid-extra-days',
      'Fjöldi daga má ekki fara yfir ferðadaga',
      function (value) {
        const { departureDate, arrivalDate } = this.parent;

        if (!departureDate || !arrivalDate || !value) {
          return true;
        }
        const daysDifference = moment(arrivalDate).diff(
          moment(departureDate),
          'days'
        );
        return value <= daysDifference;
      }
    ),
  personalDateTo: yup.string(),
  workProject: yup.string().required(errorMessage),
  workOrder: yup.string(),
  workDepartment: yup.string().nullable(),
  workLocation: yup.string().required(errorMessage),
});
